export default "skymp5-front/f76f737805c71fc2de9fdbecb2512136.gif";